import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  Optional,
  Renderer2,
  Self,
  SimpleChanges
} from '@angular/core';
import {Subscription} from "rxjs";
import {AbstractControl, FormControlName} from '@angular/forms';
import {TranslateService} from "@ngx-translate/core";
import {InputDirectiveType} from "../common/interface/input-directive.type";
import {LoadingState} from '../state/loading-state.service';

@Directive()
export class InputRootController implements AfterViewInit, OnChanges, OnDestroy, InputDirectiveType<any>
{
  @Input() public placeholder: string | undefined;

  @Input() public disabled: boolean = false;

  @Input() public title: string | undefined;
  
  private _stateDisabled: boolean | undefined;

  private subscription: Subscription;

  constructor(
    @Optional() @Self() @Inject(FormControlName) protected formControl: FormControlName,
    protected cdr: ChangeDetectorRef,
    protected elementRef: ElementRef<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
    protected renderer:Renderer2,
    protected translate: TranslateService,
    protected loadingState: LoadingState
  ) {

    this.subscription = this.loadingState.stateChanged
      .subscribe((e) => {
        if (!this.disabled && !this._stateDisabled) {
          e
            ? this.renderer.setAttribute(this.elementRef.nativeElement, "disabled", "disabled")
            : this.renderer.removeAttribute(this.elementRef.nativeElement, "disabled");
        }
      });
  }


  public ngOnChanges(changes: SimpleChanges): void {
    if (changes["placeholder"]) {
      this.injectPlaceholder();
    }
    
    if (changes["disabled"] && this.elementRef) {
      this.disabled
        ? this.renderer.setAttribute(this.elementRef.nativeElement, "disabled", "disabled")
        : this.renderer.removeAttribute(this.elementRef.nativeElement, "disabled");
    }
    
    if (changes['title'] && this.elementRef && this.translate) {
      if(this.title){
        this.translate.get(this.title)
        .subscribe(result => { 
          this.renderer.setAttribute(this.elementRef.nativeElement, 'title', result ? result : '');
        });  
      }
    }
  }

  public ngAfterViewInit(): void {
    if (this.formControl) {
      this.subscription.add(
        this.formControl.control?.registerOnDisabledChange(state => { this._stateDisabled = state })
      );
    }
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public setAttribute(attribute: { name: string; value: string }): void {
    if (this.elementRef.nativeElement) {
      this.renderer.setAttribute(this.elementRef.nativeElement, 
        attribute.name,
        attribute.value
      );
    }
  }

  public removeAttribute(attribute:string): void {
    if (this.elementRef.nativeElement) {
      this.renderer.removeAttribute(this.elementRef.nativeElement,
        attribute
      );
    }
  }

  public getAttribute(attribute: string): string | null {
    return this.elementRef.nativeElement.getAttribute(attribute);
  }

  public setId(id: string): void {
    if (this.elementRef.nativeElement) {
      this.renderer.setAttribute(this.elementRef.nativeElement, 'id', id);
      this.renderer.setAttribute(this.elementRef.nativeElement, 'name', id);
    }
  }
  
  public getElementRef() : ElementRef{
    return this.elementRef as ElementRef;
  }

  public getFormControl(): AbstractControl {
    return this.formControl?.control as AbstractControl;
  }

  private injectPlaceholder(): void {
    if (this.elementRef.nativeElement.type !== "select-one") {
      let placeholder = this.elementRef.nativeElement.getAttribute("placeholder") ?? this.placeholder ?? null;
      if (placeholder) {
        this.translate.get(placeholder)
        .subscribe(result => { 
          this.renderer.setAttribute(this.elementRef.nativeElement, 'placeholder', result ? result : placeholder);
        }); 
      }
    }
  }
}
